import Navbar from '../../components/feature/Navbar';
import Footer from '../home/components/Footer';

export default function SurfLessons() {
  const packages = [
    {
      title: 'Beginner Package',
      duration: '2 Hours',
      price: '€40',
      icon: 'ri-user-smile-line',
      color: 'teal',
      features: [
        'Beach safety & ocean awareness',
        'Surfboard basics & paddling techniques',
        'Standing up & catching waves',
        'All equipment included',
        'Small group (max 6 students)',
        'Certified instructor'
      ],
      popular: false
    },
    {
      title: 'Intermediate Package',
      duration: '2 Hours',
      price: '€45',
      icon: 'ri-trophy-line',
      color: 'orange',
      features: [
        'Wave selection & positioning',
        'Turning & maneuvering techniques',
        'Reading ocean conditions',
        'All equipment included',
        'Small group (max 4 students)',
        'Advanced coaching'
      ],
      popular: true
    },
    {
      title: 'Private Session',
      duration: '2 Hours',
      price: '€80',
      icon: 'ri-vip-crown-line',
      color: 'teal',
      features: [
        'One-on-one personalized coaching',
        'Customized lesson plan',
        'Video analysis available',
        'All equipment included',
        'Flexible scheduling',
        'Expert instructor'
      ],
      popular: false
    }
  ];

  const levels = [
    {
      title: 'Complete Beginner',
      description: 'Never surfed before? Perfect! We\'ll teach you everything from scratch.',
      icon: 'ri-seedling-line',
      color: 'green'
    },
    {
      title: 'Intermediate',
      description: 'Already catching waves? Let\'s improve your technique and style.',
      icon: 'ri-rocket-line',
      color: 'blue'
    },
    {
      title: 'Advanced',
      description: 'Ready to master advanced maneuvers and bigger waves.',
      icon: 'ri-fire-line',
      color: 'red'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[70vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/18609c4e1d957d13fb7744d32bd21fde.jpg"
            alt="Surf Lessons"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Learn to Surf in Essaouira
          </h1>
          <p className="text-xl text-white/95 mb-8 max-w-2xl mx-auto">
            From your first wave to advanced maneuvers, our certified instructors will guide you every step of the way
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a
              href="#packages"
              className="bg-gradient-to-r from-teal-500 to-teal-600 text-white px-8 py-4 rounded-full font-semibold text-base whitespace-nowrap hover:from-teal-600 hover:to-teal-700 transition-all shadow-lg hover:shadow-xl cursor-pointer"
            >
              View Packages
            </a>
            <a
              href="https://wa.me/212600000000"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-gray-900 px-8 py-4 rounded-full font-semibold text-base whitespace-nowrap hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp Us
            </a>
          </div>
        </div>
      </section>

      {/* Levels Section */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              All Levels Welcome
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Whether you're stepping on a surfboard for the first time or looking to perfect your technique, we have the right program for you
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {levels.map((level, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all">
                <div className={`w-16 h-16 flex items-center justify-center bg-${level.color}-100 rounded-full mb-6`}>
                  <i className={`${level.icon} text-3xl text-${level.color}-600`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{level.title}</h3>
                <p className="text-base text-gray-600">{level.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Packages Section */}
      <section id="packages" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Surf Lesson Packages
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Choose the perfect package for your skill level and goals
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {packages.map((pkg, index) => (
              <div
                key={index}
                className={`relative bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all ${
                  pkg.popular ? 'border-2 border-orange-500' : 'border-2 border-gray-200'
                }`}
              >
                {pkg.popular && (
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 py-2 rounded-full text-sm font-semibold whitespace-nowrap">
                    Most Popular
                  </div>
                )}
                <div className={`w-16 h-16 flex items-center justify-center bg-${pkg.color}-100 rounded-full mb-6`}>
                  <i className={`${pkg.icon} text-3xl text-${pkg.color}-600`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{pkg.title}</h3>
                <p className="text-sm text-gray-600 mb-4">{pkg.duration}</p>
                <div className="mb-6">
                  <span className="text-4xl font-bold text-gray-900">{pkg.price}</span>
                  <span className="text-base text-gray-600">/person</span>
                </div>
                <ul className="space-y-3 mb-8">
                  {pkg.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-teal-600 text-lg flex-shrink-0 mt-0.5"></i>
                      <span className="text-sm text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="/contact"
                  className={`block w-full text-center bg-gradient-to-r from-${pkg.color}-500 to-${pkg.color}-600 text-white py-4 rounded-full font-semibold text-base whitespace-nowrap hover:from-${pkg.color}-600 hover:to-${pkg.color}-700 transition-all shadow-lg hover:shadow-xl cursor-pointer`}
                >
                  Book Now
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What to Expect Section */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              What to Expect
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Your surf lesson experience from start to finish
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { step: '1', title: 'Meet & Greet', description: 'Meet your instructor and group at our beach location', icon: 'ri-hand-heart-line' },
              { step: '2', title: 'Beach Theory', description: 'Learn ocean safety, wave reading, and surfboard basics', icon: 'ri-book-open-line' },
              { step: '3', title: 'Practice on Sand', description: 'Master the pop-up technique before hitting the water', icon: 'ri-footprint-line' },
              { step: '4', title: 'Surf Time!', description: 'Get in the water and catch your first waves with guidance', icon: 'ri-water-flash-line' }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-teal-500 to-teal-600 rounded-full mx-auto mb-4 shadow-lg">
                  <i className={`${item.icon} text-3xl text-white`}></i>
                </div>
                <div className="text-sm font-bold text-teal-600 mb-2">Step {item.step}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-sm text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-teal-500 to-teal-600 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")' }}></div>
        </div>
        <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to Catch Your First Wave?
          </h2>
          <p className="text-xl text-white/95 mb-8">
            Book your surf lesson today and experience the thrill of riding Essaouira's perfect waves
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a
              href="/contact"
              className="bg-white text-teal-600 px-8 py-4 rounded-full font-semibold text-base whitespace-nowrap hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl cursor-pointer"
            >
              Book Your Lesson
            </a>
            <a
              href="https://wa.me/212600000000"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 text-white px-8 py-4 rounded-full font-semibold text-base whitespace-nowrap hover:bg-green-600 transition-all shadow-lg hover:shadow-xl cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Chat on WhatsApp
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
